if (!window.THDCustomer) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//assets.homedepot-static.com/core/thd-customer/v4.12.1/thd-customer.js';
  document.getElementsByTagName('head')[0].appendChild(script);
}

const getCookie = (cname) => {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  let found = ca.find(element => element.startsWith(name) || element.startsWith(` ${name}`));
  if (found && found.length > 0) {
    found = found.trim().substring(name.length, found.length);
    if (found.startsWith('"')) found = found.substring(1);
    if (found.endsWith('"')) found = found.substring(0, found.length - 1);
    return found;
  }
  return '';
};

const cookieExists = (cookieName) => {
  const cookieValue = getCookie(cookieName) || '';
  return cookieValue.length > 0;
};

export const isLoggedIn = () => {
  if (window.THDCustomer) {
    const { isLoggedIn: isLoggedInTHD } = window.THDCustomer.default;
    return isLoggedInTHD;
  }
  return null;
};

export const isInternalUser = () => cookieExists('internalUser');

export const getAnalyticsAuthenticationStatus = () => {
  if (isInternalUser()) {
    return 'rep';
  }

  return isLoggedIn() ? 'consumer' : 'guest';
};

export const getLoggedInUserInfo = () => {
  if (window.THDCustomer) {
    const { email, svocID } = window.THDCustomer.default;
    return {
      identityId: svocID,
      email,
    };
  }
  return {};
};
